/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ComuneDTO
 */
export interface ComuneDTO {
    /**
     * 
     * @type {string}
     * @memberof ComuneDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ComuneDTO
     */
    descrizione?: string;
    /**
     * 
     * @type {string}
     * @memberof ComuneDTO
     */
    provinciaId?: string;
    /**
     * 
     * @type {string}
     * @memberof ComuneDTO
     */
    nazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof ComuneDTO
     */
    regioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof ComuneDTO
     */
    provincia?: string;
    /**
     * 
     * @type {string}
     * @memberof ComuneDTO
     */
    nazione?: string;
    /**
     * 
     * @type {string}
     * @memberof ComuneDTO
     */
    regione?: string;
}

/**
 * Check if a given object implements the ComuneDTO interface.
 */
export function instanceOfComuneDTO(value: object): value is ComuneDTO {
    return true;
}

export function ComuneDTOFromJSON(json: any): ComuneDTO {
    return ComuneDTOFromJSONTyped(json, false);
}

export function ComuneDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComuneDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
        'provinciaId': json['provinciaId'] == null ? undefined : json['provinciaId'],
        'nazioneId': json['nazioneId'] == null ? undefined : json['nazioneId'],
        'regioneId': json['regioneId'] == null ? undefined : json['regioneId'],
        'provincia': json['provincia'] == null ? undefined : json['provincia'],
        'nazione': json['nazione'] == null ? undefined : json['nazione'],
        'regione': json['regione'] == null ? undefined : json['regione'],
    };
}

export function ComuneDTOToJSON(value?: ComuneDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'descrizione': value['descrizione'],
        'provinciaId': value['provinciaId'],
        'nazioneId': value['nazioneId'],
        'regioneId': value['regioneId'],
        'provincia': value['provincia'],
        'nazione': value['nazione'],
        'regione': value['regione'],
    };
}

